import * as yup from "yup";

export const BookingSchema = yup.object().shape({
  date: yup.array().required("Date is required"),
  time: yup.string().required("Time is required"),
  service: yup.array().required("Service is required"),
});
